import loadable from '@loadable/component';

import { BoxIndicator } from '@classtinginc/design-system';

const NotificationsPage = loadable(() => import('./NotificationsPage'), {
  fallback: <BoxIndicator />,
});

export default NotificationsPage;
